<div class="flex flex-col gap-3 text-sm">
  <div class="flex justify-between items-center">
    <label class="font-semibold">
      {{ 'customerPreference.logoLabel' | translate }}
    </label>
    @if (currentLogoUrl() && !selectedFile()) {
      <p-button
        [label]="'customerPreference.removeLogo' | translate"
        icon="pi pi-trash"
        severity="danger"
        [text]="true"
        [size]="'small'"
        [disabled]="isLoading()"
        (click)="deleteLogo(); $event.stopPropagation()" />
    }
  </div>

  <!-- Upload Zone -->
  <div
    class="logo-upload-zone group"
    [class.has-file]="selectedFile() || currentLogoUrl()"
    (click)="triggerFileInput()">

    @if (isLoading()) {
      <div class="flex flex-col items-center justify-center gap-3 py-8">
        <i class="pi pi-spin pi-spinner text-3xl text-primary"></i>
        <span class="text-sm text-slate-500">Processing...</span>
      </div>
    } @else if (previewUrl() || currentLogoUrl()) {
      <div class="relative w-full flex justify-center py-4 px-4 bg-white dark:bg-slate-900 rounded-lg">
        <img [src]="previewUrl() || currentLogoUrl()" alt="Logo" class="logo-preview drop-shadow-sm" />
        <div class="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center rounded-lg cursor-pointer backdrop-blur-[2px]">
          <div class="flex items-center gap-4 text-white">
            <i class="pi pi-pencil text-2xl mb-1"></i>
            <span class="text-xs font-medium">{{ 'customerPreference.changeLogo' | translate }}</span>
          </div>
        </div>
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center py-6 px-4 text-center cursor-pointer transition-colors rounded-xl">
        <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-200">
          <i class="pi pi-cloud-upload text-2xl text-primary"></i>
        </div>
        <h4 class="text-sm font-semibold text-slate-700 dark:text-slate-200 mb-2">
          {{ 'customerPreference.selectLogo' | translate }}
        </h4>
        <p class="text-xs text-slate-500 dark:text-slate-400 max-w-xs leading-relaxed">
          {{ 'customerPreference.hint' | translate }}
        </p>
      </div>
    }
  </div>

  <!-- File Info -->
  @if (selectedFile()) {
    <div class="flex items-center justify-between p-3 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm">
      <div class="flex items-center gap-3 overflow-hidden">
        <div class="w-10 h-10 rounded bg-primary/10 flex items-center justify-center flex-shrink-0">
          <i class="pi pi-image text-primary text-lg"></i>
        </div>
        <div class="flex flex-col truncate">
          <span class="text-sm font-medium text-slate-700 dark:text-slate-200 truncate" [title]="selectedFile()!.name">
            {{ selectedFile()!.name }}
          </span>
          <span class="text-xs text-slate-500">{{ (selectedFile()!.size / 1024).toFixed(1) }} KB</span>
        </div>
      </div>
      <p-button
        icon="pi pi-times"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        (click)="cancelSelectedFile(); $event.stopPropagation()" />
    </div>
  }

  <!-- Hidden File Input -->
  <input
    #logoFileInput
    type="file"
    accept=".png,.jpg,.jpeg,.webp,.gif,image/png,image/jpeg,image/webp,image/gif"
    (change)="onFileSelected($event)"
    class="hidden" />

  @if (selectedFile()) {
    <div>
      <p-button
        [label]="'customerPreference.uploadLogo' | translate"
        icon="pi pi-check"
        (click)="uploadLogo()"
        [disabled]="isLoading()"
        [loading]="isLoading()" />
    </div>
  }
</div>

<p-confirmDialog />
